import React, { useRef, useEffect } from 'react';
import { EntryType, EntryModel } from 'lib/models';
import TextEditor from "components/TextEditor";
import { FaChevronDown } from 'react-icons/fa';
import Button, { ButtonVariant } from 'components/Button';

interface SearchResultsContainerProps {
  results: EntryModel[];
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

function SearchResultsContainer({results, isCollapsed, setIsCollapsed}: SearchResultsContainerProps) {
  const chatContainerRef = useRef<HTMLDivElement|null>(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [results]);

  const renderResult = (result: EntryModel, key: string) => {
    switch(result.data.type) {
        case EntryType.TEXT: {
          return (
            <div className="h-fit w-fit border" key={key}>
              <TextEditor
                initialText={result.data.text}
                readOnly={true}/>
            </div>
          );
        }
        case EntryType.WORKSPACE: {
          return (
            <div className="w-fit p-2 bg-palette-4 rounded-3xl" key={key}>
              {`Workspace: ${result.createdAt}`}
            </div>
          );
        }
    }
  };

  if (isCollapsed) {
    return null;
  }

  return (
      <div>
        <div
           ref={chatContainerRef}
           className={`grid grid-cols-3 gap-2 col-span-full h-fit overflow-y-auto max-h-[calc(100vh-350px)]`}
        >
          {results.map((result, idx) => renderResult(result, `query:result:${idx}`))}
        </div>
        <div className="flex flex-row justify-end py-4">
          <Button
            variant={ButtonVariant.FlatNoFill}
            icon={<FaChevronDown />}
            onClick={() => setIsCollapsed(true)}
            size="sm"
          />
        </div>
        <hr className="border-t-2 border-palette-4" />
      </div>
  );
}

export default SearchResultsContainer;
